import React from 'react';

export default function LingonSVG() {
  return (
    <svg
      // width="50"
      // height="50"
      viewBox="0 0 497 497"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M377.925 476.344c.139 4.091-.928 7.839-2.835 10.986-1.449 2.391-11.164-2.436-13.42-.851-1.922 1.35 3.704 9.239 1.413 9.852-3.957 1.058-8.315.912-12.56-.799-8.526-3.437-18.382-7.798-28.535-13.087-2.247-1.17-1.968-10.023-4.232-11.285-2.287-1.274-7.117 5.044-9.4 3.677a217.974 217.974 0 01-13.252-8.578c-12.799-8.983-11.25-36.094-19.731-48.206-20.799-29.704-39.302-58.184-40.297-87.397-.492-14.421 14.019-24.582 27.403-19.188 27.111 10.927 53.627 37.637 74.427 67.342 8.534 12.188 28.478 20.53 32.544 35.73a209.085 209.085 0 012.229 9.17c.516 2.346-3.809 5.536-3.369 7.875.499 2.657 5.752 4.46 6.161 7.085 2.128 13.682 3.083 26.779 3.454 37.674z"
        fill="#92b738"
      />
      <path
        d="M375.09 487.33a20.12 20.12 0 01-12.01 8.99l-33.61-46.04-7.48 32.16a259.3 259.3 0 01-13.63-7.61l9.43-40.55-24.46-33.51c-2.45-3.34-1.71-8.03 1.63-10.48 3.35-2.44 8.04-1.71 10.48 1.64l23.69 32.44 42.55-.66c1.1 5.01 2.02 10.03 2.79 14.96l-34.51.54z"
        fill="#87a733"
      />
      <path
        d="M369.45 414.54c-8.08 1.63-16.44 2.49-24.99 2.49-10.47 0-20.65-1.28-30.39-3.7-1.5 19.58-8.3 37.7-18.96 52.92-12.8-8.97-24.57-19.52-33.05-31.63-15.21-21.73-22.08-51.67-25.05-77.61-1.1-9.52-1.67-18.51-1.94-26.35-.42-12.25 9.97-21.42 21.31-20.61 2.02.14 4.08.61 6.1 1.42 27.11 10.93 67.66 31.21 88.46 60.91 8.53 12.19 14.44 26.96 18.51 42.16z"
        fill="#87a733"
      />
      <path
        d="M322.35 415.09c-2.79-.5-5.55-1.08-8.28-1.76-.35 4.51-.97 8.95-1.87 13.29l-18.87-25.85c-2.45-3.34-1.71-8.03 1.63-10.48 3.35-2.44 8.04-1.71 10.48 1.64z"
        fill="#7e9930"
      />
      <path
        d="M185.79 308.707c14.313 2.024 21.813 18.107 14.163 30.372-15.496 24.846-43.235 49.069-76.159 64.421-8.427 3.929-16.991 18.933-26.563 20.774-6.172 1.188-12.483 1.999-18.801 2.51-2.528.204-3.514-5.943-6.036-5.83-2.84.127-7.213 6.503-10.024 6.527-16.58.142-32.442-1.39-45.16-3.188-4.537-.641-8.389-2.695-11.291-5.592-2.248-2.244 8.991-4.55 8.006-7.541-.613-1.863-13.875-4.263-13.92-6.249-.085-3.697.865-7.498 3.042-10.989 6.909-11.077 16.117-24.466 27.118-37.265 1.853-2.155 9.893-2.019 11.845-4.127 1.632-1.762-2.839-5.779-1.141-7.49 7.377-7.434 15.366-14.312 23.851-19.969 4.471-2.981 22.603 6.135 27.333 3.929 32.923-15.353 64.743-24.393 93.737-20.293z"
        fill="#92b738"
      />
      <path
        d="M131.67 364.65l-37.74 16.22-15.5 45.92c-5.37.43-10.75.65-16.06.69l13.04-38.65L5.92 418.7c-3.65-3.64-5.8-8.62-5.91-13.79L70 374.83l-39.83-18.17c3.4-3.96 6.97-7.86 10.7-11.62l47.74 21.79 37.13-15.96c3.81-1.64 8.22.12 9.86 3.93 1.63 3.8-.13 8.21-3.93 9.85z"
        fill="#87a733"
      />
      <path
        d="M199.95 339.08c-15.49 24.84-42.56 61.33-75.48 76.68-8.43 3.93-17.67 6.68-27.24 8.51-1.09-6.23-1.65-12.63-1.65-19.17 0-15.16 3.04-29.62 8.53-42.82a129.562 129.562 0 01-39.39-37.21c4.47-2.98 9.08-5.62 13.81-7.83 32.92-15.35 78.27-12.63 107.26-8.53 14.31 2.02 21.81 18.1 14.16 30.37z"
        fill="#87a733"
      />
      <path
        d="M131.67 364.65l-32.95 14.16a108.25 108.25 0 015.39-16.53c-.67-.41-1.34-.82-2-1.25l23.63-10.16c3.81-1.64 8.22.12 9.86 3.93 1.63 3.8-.13 8.21-3.93 9.85z"
        fill="#7e9930"
      />
      <path
        d="M474.253 59.879c4.976-.083 9.473 1.421 13.129 3.977 2.573 1.799-5.284 11.457-3.669 14.111 1.03 1.693 11.853-3.816 12.41-1.899 1.356 4.671 1.208 9.863-.915 14.877-7.417 17.515-18.458 40.051-33.011 60.319-1.734 2.415-9.076 2.493-10.909 4.831-1.749 2.231 2.014 6.726.174 8.865-6.924 8.051-14.485 15.376-22.677 21.405-1.172.862-38.5 4.666-39.697 5.474-53.402 36.02-109.718 29.362-109.718 29.362l73.879-130.293a106.062 106.062 0 013.995-2.832c8.997-6.069 19.199-10.868 29.944-14.654 2.868-1.01 3.465 4.395 6.398 3.524 2.729-.811 7.791-7.907 10.555-8.605 24.806-6.26 50.617-8.138 70.112-8.462z"
        fill="#92b738"
      />
      <path
        d="M395.61 142.35l66.58 8.91c-3.38 4.72-6.96 9.32-10.73 13.7l-74.93-10.03-50.11 33.04c-1.27.84-2.7 1.24-4.12 1.24a7.53 7.53 0 01-6.27-3.37 7.5 7.5 0 012.14-10.39l50.09-33.03 18.93-68.99c5.53-1.96 11.22-3.64 16.95-5.09l-16.89 61.55 100.13-66.03a22.66 22.66 0 018.74 12.21z"
        fill="#87a733"
      />
      <path
        d="M428.78 186.36c-1.17.87-2.35 1.7-3.55 2.51-26.27 17.72-62.81 24.62-93.15 27.06-31.34 2.51-56.08.27-56.08.27s7.03-23.25 20.8-50.96c12.94-26.05 31.84-56.03 56.45-74.33 2.65 11.41 4.19 22.96 4.19 34.35 0 10.46-1.32 21.06-3.6 31.56 28.27 1.96 54.16 12.72 74.94 29.54z"
        fill="#87a733"
      />
      <path
        d="M370.35 159l-43.93 28.97c-1.27.84-2.7 1.24-4.12 1.24a7.53 7.53 0 01-6.27-3.37 7.5 7.5 0 012.14-10.39l36.8-24.27c-.34 1.88-.72 3.76-1.13 5.64 5.6.39 11.11 1.12 16.51 2.18z"
        fill="#7e9930"
      />
      <path
        d="M254.521 17.032c6.021-9.254 15.985-18.984 25.337-15.828 4.596 1.551 8.775 4.6 11.733 9.147 5.694 8.752 12.019 19.222 18.024 30.746 1.761 3.381-6.734 10.177-5.052 13.722.644 1.358 11.51-.598 12.138.78 4.403 9.67 8.367 19.828 11.426 30.149 1.128 3.807-3.316 13.236-2.457 17.071.459 2.052 6.326-1.493 6.697.559 1.33 7.344 2.077 14.677 2.077 21.885 0 65.638-61.945 141.64-61.945 141.64s-56.447-74.732-56.447-140.369c.001-41.407 20.269-81.528 38.469-109.502z"
        fill="#92b738"
      />
      <path
        d="M302.71 222.02c-15.23 26.49-30.21 44.88-30.21 44.88s-61.94-76-61.94-141.64c0-7.161.737-14.445 2.051-21.742.613-3.402 5.729.07 6.576-3.326.621-2.491-3.076-11.854-2.344-14.331 3.052-10.323 7.011-20.484 11.411-30.159 1.514-3.329 7.459.276 9.058-2.925.792-1.586-2.785-10.031-1.979-11.58 6.02-11.565 12.365-22.071 18.076-30.847 3.95-6.08 10.09-9.48 16.48-10.2-13.4 25.5-25.33 56.31-25.33 85.11.001 55.75 44.691 118.98 58.151 136.76z"
        fill="#87a733"
      />
      <path
        d="M264.138 260.521c0-26.604 5.666-59.233-10.209-78.121-19.929-23.711-49.807-38.78-83.205-38.78-60.002 0-108.642 48.641-108.642 108.642 0 35.374 16.907 66.8 43.08 86.638 18.222 13.811 46.774 16.089 71.401 16.089 60.002 0 87.575-34.467 87.575-94.468z"
        fill="#c42430"
      />
      <path
        d="M332.36 103.38l-52.5 57.81v44.71c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5v-44.86l-52.24-57.52c.466-2.617 3.674-2.001 4.284-4.616.766-3.281-1.027-9.789-.064-13.044l48.02 52.87V96.01L228.25 55.7c1.12-2.458 6.55-1.556 7.718-3.945 1.199-2.451-1.864-8.19-.628-10.555l29.52 32.5V1.3c4.83-1.7 10.15-1.73 15-.1v72.66l29.75-32.76c2.44 4.67 4.82 9.52 7.09 14.5l-36.84 40.57v42.71l48.26-53.13c1.74 5.84 3.18 11.74 4.24 17.63z"
        fill="#87a733"
      />
      <path
        d="M248.29 55.46c-1.48 6.27-2.57 12.56-3.18 18.81L228.25 55.7a298.064 298.064 0 017.09-14.5zm31.57 132.64v17.8c0 4.14-3.36 7.5-7.5 7.5s-7.5-3.36-7.5-7.5v-44.86l-52.24-57.52c.13-.74.27-1.48.41-2.21 1.007-5.206 2.313-10.349 3.81-15.45l33.42 36.8c6.411 23.911 18.111 47.063 29.6 65.44z"
        fill="#7e9930"
      />
      <path
        d="M265.08 1.23c-.08.02-.15.05-.22.08V1.3c.07-.03.15-.05.22-.07z"
        fill="#87a733"
      />
      <path
        d="M250.899 325.552c7.097-7.729 13.019-16.511 17.631-25.933a.229.229 0 00-.016-.009c6.946-14.314 10.855-30.374 10.855-47.351 0-26.6-9.56-50.97-25.44-69.86-28.557 23.896-47.552 58.833-50.369 98.18-.108 1.505-1.291 2.722-2.798 2.805-40.031 2.185-74.988 23.778-95.593 55.506 18.22 13.82 40.93 22.01 65.55 22.01 16.389 0 31.925-3.637 45.858-10.134l.002.004c12.946-6.052 24.688-14.66 34.32-25.218z"
        fill="#a81f2a"
      />
      <path
        d="M231.51 342.31c2.1-1.42 4.15-2.91 6.14-4.47a103.4 103.4 0 01-6.14 4.47zm9.08-6.86c1.46-1.22 2.87-2.48 4.26-3.77-1.39 1.3-2.81 2.56-4.26 3.77zm9.62-9.13c-1.72 1.85-3.51 3.64-5.36 5.36 1.85-1.73 3.63-3.52 5.36-5.36zm1.28-1.4c2.53-2.82 4.92-5.77 7.16-8.84a106.32 106.32 0 01-7.16 8.84zm17.04-25.3c-.27.57-.55 1.13-.84 1.69.28-.56.56-1.13.83-1.7 0 .01.01.01.01.01z"
        fill="#c42430"
      />
      <path
        d="M455.725 290.765c0-61.45-49.815-111.265-111.265-111.265-59.836 0-108.641 47.233-111.163 106.449-.068 1.597 46.073 54.125 46.073 54.125l49.939 60.933a112.348 112.348 0 0015.151 1.023c61.45 0 111.265-49.815 111.265-111.265z"
        fill="#e03c3e"
      />
      <path
        d="M329.31 401c-54.29-7.38-96.12-53.92-96.12-110.23 0-1.62.03-3.22.11-4.82 53.57 11.6 94.14 58.51 96.01 115.05z"
        fill="#c42430"
      />
      <path
        d="M299.384 405.1c0-50.755-41.145-91.9-91.9-91.9-28.905 0-54.693 13.344-71.539 34.208-12.735 15.772-12.147 41.305-12.147 63.155 0 50.755 76.596 75.915 76.596 75.915s81.624-15.413 94.024-51.5c3.219-9.367 4.966-19.418 4.966-29.878z"
        fill="#e03c3e"
      />
      <path
        d="M296.92 426.29c-9.56 40.54-45.97 70.71-89.44 70.71-50.75 0-91.9-41.14-91.9-91.9 0-23.02 8.47-44.07 22.46-60.19-1.61 6.8-2.46 13.9-2.46 21.19 0 50.76 41.15 91.9 91.9 91.9 27.74 0 52.6-12.28 69.44-31.71z"
        fill="#c42430"
      />
      <ellipse
        cx="135.889"
        cy="216.685"
        fill="#a81f2a"
        rx="35.856"
        ry="24.149"
        transform="rotate(-45 135.859 216.726)"
      />
      <ellipse
        cx="198.236"
        cy="369.992"
        fill="#c42430"
        rx="24.984"
        ry="16.827"
        transform="rotate(-14.6 198.142 369.833)"
      />
      <ellipse
        cx="389.088"
        cy="252.262"
        fill="#c42430"
        rx="21.133"
        ry="31.377"
        transform="rotate(-45 389.072 252.352)"
      />
    </svg>
  );
}
